export default __webpack_public_path__ + "static/media/Dashboard.385cdcfe.svg";